<template>
    <div class="virtual">
         <div class="video">
            <video 
                muted
                ref="video" 
                autoplay 
                loop
                @pause="pauseVideo" 
                @canplaythrough="videoLoaded"
                webkit-playsinline="true"
                playsinline="true"
                x5-video-player-type="h5"
                x5-video-orientation="portraint"
                src="http://ii.sinelinked.com/download/small.mp4" 
                controls width="100%">
            </video>
            <div class="video_bg" v-if="onOff" @click="autoPlayClick"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'virtual',
    data() {
        return {
            onOff: false,
        }
    },
    mounted() {
        let This = this
        this.$refs.video.play();
        console.log(this.$refs.video); 
        document.addEventListener("WeixinJSBridgeReady", function () { 
            This.$refs.video.play();
        }, false); 
    },
    methods: {
        videoLoaded(){
    　　　　this.$refs.video.play();
    　　},
        pauseVideo() {
            this.onOff = !this.onOff
        },
        autoPlayClick(){
            this.onOff = !this.onOff
            console.log(this.$refs.video);
            this.$refs.video.play()
        },
    },
}
</script>

<style scoped>
    .video .video_bg{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background: url('../../assets/images/video_bg.jpg') no-repeat;
        background-size: 100%; 
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>